import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./FestivalPostFilter.scss";
import { useFormik } from "formik";
import * as Yup from "yup";
import { RootState } from "../../../../../redux/store";
import { AuthHelpers } from "../../../../../utils/auth.helpers";
import { commonAction } from "../../../../../redux/features/commonSlice";
import { CommonEnums } from "../../../../../enums/common.enums";
import { propertieAction } from "../../../../../redux/features/propertieSlice";
import CloseIcon from "../../../../../components/icons/CloseIcon";
import FilterAgentSearch from "../../../properties/filter/FilterAgentSearch";
import Loading from "../../../../loading/Loading";
import ActivitiesFilterDates from "../../activities/Activitiesfilterdate";
import { PropertyApi } from "../../../../../utils/api/Property";
import FilterFestivalType from "./FilterFestivalType";
import FestivalFilterStatusSelect from "./FestivalFilterStatusSelect";
import FestivalFilterPostType from "./FestivalFilterPostType";

const FestivalPostFilter = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let filterBox = useSelector(
    (state: RootState) => state?.common?.homePageFilter
  );
  const [searchParams, setSearchParams] = useSearchParams();
  const userType = AuthHelpers.getUserType();
  let is_user_validation = AuthHelpers.userValidation();
  const filterRef = useRef<HTMLDivElement>(null);

  const [state, setState] = useState({
    isLoading: true,
    listingTypeData: [],
    propertyStageData: [],
    propertyTypeData: {
      residential: [],
      commercial: [],
    },
  });
  const onCloseFilter = () => {
    dispatch(commonAction.setHomePageFilter());
  };

  const onSubmitHandler = async (values: any) => {
    const queryParams = new URLSearchParams(searchParams);

    const subscriptionType = searchParams.get("subscription_type");
    if (subscriptionType) {
      queryParams.set("subscription_type", subscriptionType);
    }

    // queryParams.set(
    //   CommonEnums.queryParams.agent_id,
    //   values?.selectedAgentIds?.toString() || ""
    // );
    // queryParams.set(
    //   CommonEnums.queryParams.activitiesFilter.listing_type,
    //   values?.selectedListingTypeKey || ""
    // );

    // queryParams.set(
    //   CommonEnums.queryParams.propertiesFilter.property_type,
    //   values?.selectedPropertyTypeIds?.toString() || ""
    // );
    // queryParams.set(
    //   CommonEnums.queryParams.activitiesFilter.property_stage,
    //   values?.selectPropertyStageIds?.toString() || ""
    // );
    queryParams.set(
      CommonEnums.queryParams.activitiesFilter.festival_type,
      values?.festival_type || ""
    );
    queryParams.set(
      CommonEnums.queryParams.activitiesFilter.post_status,
      values?.post_status || ""
    );
    queryParams.set(
      CommonEnums.queryParams.activitiesFilter.post_type,
      values?.selectedPostType || ""
    );
    queryParams.set(
      CommonEnums.queryParams.activitiesFilter.start_date,
      values?.startDate || ""
    );
    queryParams.set(
      CommonEnums.queryParams.activitiesFilter.end_date,
      values?.endDate || ""
    );

    if (values?.selectedPropertyId) {
      queryParams.set(
        CommonEnums.queryParams.activitiesFilter.property_id,
        values?.selectedPropertyId
      );
    }

    navigate(`/workspace/festival-post-list?${queryParams.toString()}`);
    onCloseFilter();
    dispatch(propertieAction.setInvitesListReset());
  };

  const initialValues: any = {
    selectedAgentIds: [],
    selectedPropertyId: "",
    selectedListingTypeKey: "",
    selectedPropertyTypeIds: [],
    selectPropertyStageIds: [],
    post_status: "",
    postType: "",
    startDate: "",
    endDate: "",
  };

  const formik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      selectedAgentIds: Yup.array().optional(),
      selectedListingIds: Yup.array().optional(),
      selectedPropertyTypeIds: Yup.array().optional(),
      selectPropertyStageIds: Yup.array().optional(),
      startDate: Yup.string().optional(),
      endDate: Yup.string().optional(),
    }),
    onSubmit: onSubmitHandler,
    validateOnChange: false,
    validateOnBlur: false,
    validateOnMount: false,
  });

  const getSelectBoxValuesApi = async () => {
    setState({
      ...state,
      isLoading: true,
    });
    let res = await PropertyApi.getSelectors();

    if (res?.data?.success) {
      let resData = res.data.data;
      setState({
        ...state,
        isLoading: false,
        listingTypeData: resData?.listing_types,
        propertyTypeData: resData?.property_types,
        propertyStageData: resData?.property_stages,
      });
    } else {
      setState({
        ...state,
        isLoading: false,
      });
      toast.error(res?.data?.message || "Internal server error!");
    }
  };

  const onClickClear = () => {
    formik.resetForm({
      values: {
        selectedAgentIds: [],
        selectedPropertyId: "",
        selectedProperty: null,
        selectedListingTypeKey: "",
        selectedPropertyTypeIds: [],
        selectPropertyStageIds: [],
        post_status: "",
        post_type: "",
        startDate: "",
        endDate: "",
      },
    });

    const params = new URLSearchParams(window.location.search);
    const subscriptionType = params.get("subscription_type");

    const newParams = new URLSearchParams();
    if (subscriptionType) {
      newParams.set("subscription_type", subscriptionType);
    }

    setSearchParams(newParams);

    dispatch(propertieAction.setInvitesListReset());

    window.location.reload();
  };

  useEffect(() => {
    getSelectBoxValuesApi();

    let listing_type_id = searchParams.get(
      CommonEnums.queryParams?.propertiesFilter?.listing_type
    );
    let agents_id = searchParams.get(CommonEnums.queryParams?.agent_id);

    let property_id =
      searchParams.get(CommonEnums.queryParams.activitiesFilter.property_id) ||
      "";

    let property_stage_id = searchParams.get(
      CommonEnums.queryParams?.activitiesFilter?.property_stage
    );
    console.log("poperty stage,", property_stage_id);
    let property_type_id = searchParams.get(
      CommonEnums.queryParams?.propertiesFilter?.property_type
    );
    let post_status =
      searchParams.get(
        CommonEnums.queryParams?.activitiesFilter?.post_status
      ) || "";

    let festival_type =
      searchParams.get(
        CommonEnums.queryParams?.activitiesFilter?.festival_type
      ) || "";

    let start_date =
      searchParams.get(CommonEnums.queryParams.activitiesFilter.start_date) ||
      "";
    let end_date =
      searchParams.get(CommonEnums.queryParams.activitiesFilter.end_date) || "";

    formik.setFieldValue(
      "selectedAgentIds",
      agents_id ? agents_id?.split(",") : []
    );
    formik.setFieldValue("selectedListingTypeKey", listing_type_id || "");
    formik.setFieldValue("selectedPropertyId", property_id);
    if (!property_id) formik.setFieldValue("selectedProperty", null);
    formik.setFieldValue(
      "selectedPropertyTypeIds",
      property_type_id ? property_type_id?.split(",") : []
    );
    formik.setFieldValue(
      "selectPropertyStageIds",
      property_stage_id ? property_stage_id?.split(",") : []
    );
    formik.setFieldValue("post_status", post_status);
    formik.setFieldValue("festival_type", festival_type);
    formik.setFieldValue("startDate", start_date);
    formik.setFieldValue("endDate", end_date);
  }, [searchParams]);

  console.log("formik>>", formik?.values);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        filterRef.current &&
        !filterRef.current.contains(event.target as Node)
      ) {
        document.dispatchEvent(new Event("closeAllDropdowns"));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <form onSubmit={formik.handleSubmit}>
      <div
        className={`properties-filter-container ${
          filterBox ? "" : "deactivate-filter"
        }`}
      >
        <div className="filter-background" onClick={onCloseFilter}></div>
        <div className="properties-filter-box">
          <div className="filter-top-heading">
            <p className="filter-top-head">Filters</p>
            <div className="filter-close-icon" onClick={onCloseFilter}>
              <CloseIcon />
            </div>
          </div>
          <div className="filter-body-container">
            {/* {AuthHelpers.getUserType() === CommonEnums.userRole.agency && (
              <FilterAgentSearch formik={formik} />
            )} */}

            {state.isLoading ? (
              <div className="property-filter-is-loading-contain">
                <Loading />
              </div>
            ) : (
              <>
                {/* <FilterPropertySelect formik={formik} /> */}

                <FilterFestivalType formik={formik} />

                <FestivalFilterStatusSelect formik={formik} />

                <FestivalFilterPostType formik={formik} />

                {/* <FilterPropertyType
                  formik={formik}
                  listData={state?.propertyTypeData}
                /> */}

                {/* <ActivitiesFilterPropertyStage
                  formik={formik}
                  listData={state?.propertyStageData}
                /> */}

                <ActivitiesFilterDates formik={formik} lable="Schedule Date" />
              </>
            )}
          </div>

          <div className="action-btn-filter">
            <button
              className="clear-filters-btn"
              type="reset"
              onClick={onClickClear}
            >
              Clear Filters
            </button>
            <button className="apply-btn" type="submit">
              Apply
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default FestivalPostFilter;
